import AbstractCommand from "../../../../../../shared/src/ranj/app/core/AbstractCommand";
import SkinKeys from "../../../../../../shared/src/ranj/app/ui/SkinKeys";

export default class GameCompletedCommand extends AbstractCommand {

    /**
     * @param {soma.EventDispatcher} dispatcher 
     */
     constructor(dispatcher) {
        super(dispatcher);

        this.execute = function(event) {
            this.gotoScreen(SkinKeys.END_SCREEN);
        };
    }

}